import fetch from '@giro/shared-utils/fetch.util';

export type BodyType = {
  doing: string;
};

export default async function postApiSlipService(body: any) {
  const { token, ...bodyData } = body;
  const { app, ...payload } = bodyData;

  return fetch(`${app}/boletos`, {
    method: 'POST',
    ms: 'PDV',
    auth: true,
    body: JSON.stringify(payload),
  });
}
